export default "__VITE_ASSET__CFjJGTQ1__"